<div class="overflow-x-hidden">
  <div class="absolute inset-0">
    <img src="../../../assets/images/notification-bg.png" alt="image" class="h-full w-full object-fill" />
  </div>
  <div class="relative flex min-h-screen items-center justify-center bg-cover bg-center bg-no-repeat px-6 py-10 dark:bg-[#060818] sm:px-16">
    <img src="../../../assets/images/notification-bg.png" alt="image" class="absolute left-0 top-1/2 h-full max-h-[893px] -translate-y-1/2" />
    <img src="../../../assets/images/notification-bg.png" alt="image" class="absolute left-24 top-0 h-40 md:left-[30%]" />
    <img src="../../../assets/images/notification-bg.png" alt="image" class="absolute right-0 top-0 h-[300px]" />
    <img src="../../../assets/images/notification-bg.png" alt="image" class="absolute bottom-0 end-[28%]" />
    <div
      class="relative flex w-full max-w-[1502px] flex-col justify-between overflow-hidden rounded-md bg-white/60 backdrop-blur-lg dark:bg-black/50 lg:min-h-[500px] lg:flex-row lg:gap-0 xl:gap-0"
    >
      <div
        class="relative hidden w-auto items-center justify-center bg-[linear-gradient(225deg,#00022e_100%)] lg:inline-flex lg:max-w-[835px] xl:-ms-28 ltr:xl:skew-x-[14deg] rtl:xl:skew-x-[-14deg]"
      >
        <div
          class="absolute inset-y-0 w-8 from-primary/100 via-transparent to-transparent ltr:-right-10 ltr:bg-gradient-to-br rtl:-left-10 rtl:bg-gradient-to-l xl:w-16 ltr:xl:-right-20 rtl:xl:-left-20"
        ></div>
        <div class="ltr:xl:-skew-x-[14deg] rtl:xl:skew-x-[14deg]-">
          <!-- <a routerLink="/" class="ms-10 block w-48 lg:w-72">
                        <img src="../../../assets/images/notification-bg.png" alt="Logo" class="w-full" />
                    </a>  -->
          <div class="hidden w-full h-full lg:block">
            <img [src]="currentImage" alt="Cover Image" class="w-full trapezoid animate__animated animate__fadeIn animate__delay-1s" />
            <!-- <img src="../../../../assets/images/pit2inglish.jpg" alt="Cover Image" class="w-full pl-14 trapezoid animate__animated animate__fadeIn animate__delay-1s" /> -->
          </div>
        </div>
      </div>
      <div class="relative flex w-full flex-col items-center justify-center gap-6 px-4 pb-16 pt-6 sm:px-6 lg:max-w-[667px]">
        <div class="flex w-full max-w-[440px] items-center gap-2 lg:absolute lg:end-6 lg:top-6 lg:max-w-full">
          <app-languajes class="dropdown w-full"></app-languajes>
        </div>
        <div class="w-full max-w-[440px] lg:mt-16">
          <div class="mb-10">
            <h1
              *ngIf="!isPhoneLogin"
              class="text-3xl font-extrabold uppercase !leading-snug text-primary md:text-4xl animate__animated animated__delay-1s animate__fadeInDown"
            >
              {{ 'LOGIN.TITLE' | translate }}
            </h1>
            <h1
              *ngIf="isPhoneLogin"
              class="text-3xl font-extrabold uppercase !leading-snug text-primary md:text-4xl animate__animated animated__delay-1s animate__fadeInDown"
            >
              {{ 'LOGIN.LOGIN_AS_PHONE' | translate }}
            </h1>
            <p class="text-base font-bold leading-normal text-white-dark animate__animated animated__delay-1s animate__slideInUp">
              {{ 'LOGIN.SUBTITLE' | translate }} . <icon-login class="inline-block text-primary animate__animated animate__fadeInTopRight animated__delay-1s" />
            </p>
          </div>
          <!-- 🔄 Switch para alternar -->
          <div class="flex justify-center mb-4">
              <span *ngIf="isPhoneLogin" class="text-sm font-bold text-primary pr-5">Correo</span>
              <label class="switch">
                  <input type="checkbox" [(ngModel)]="isPhoneLogin" />
                  <span class="slider"></span>
                </label>
                <span *ngIf="!isPhoneLogin" class="text-sm font-bold text-primary pl-5">Telefono</span>
          </div>

          <form *ngIf="isPhoneLogin" [formGroup]="loginPhoneForm" class="space-y-5 dark:text-white">
            <div>
              <label for="Phone">{{ 'LOGIN.PHONE' | translate }}</label>
              <div class="relative text-white-dark">
                <input
                  id="Phone"
                  type="tel"
                  formControlName="phone"
                  placeholder="+57 3001234567"
                  class="form-input ps-10 placeholder:text-white-dark animate__animated animate__fadeInTopRight animated__delay-1s"
                />
                <span class="absolute start-4 top-1/2 -translate-y-1/2">
                  <icon-phone class="text-primary" [fill]="true"></icon-phone>
                </span>
              </div>

              <div *ngIf="loginPhoneForm.get('phone')?.invalid && loginPhoneForm.get('phone')?.touched" class="text-red-500">
                <small>⚠️ {{ 'LOGIN.INVALIDE_PHONE' | translate }}</small>
              </div>
            </div>
            <button (click)="onSubmitPhone()" class="btn btn-primary w-full">
              {{ 'LOGIN.SEND_CODE' | translate }}
            </button>

            <div *ngIf="showCodeInput">
              <label for="Code">{{ 'LOGIN.CODE' | translate }}</label>
              <div class="relative text-white-dark">
                <input
                  id="Code"
                  type="password"
                  formControlName="code"
                  placeholder="{{ 'LOGIN.ENTERCODE' | translate }}"
                  class="form-input ps-10 placeholder:text-white-dark animate__animated animate__fadeInTopRight animated__delay-1s"
                />
                <span class="absolute start-4 top-1/2 -translate-y-1/2">
                  <icon-lock-dots class="text-primary" [fill]="true"></icon-lock-dots>
                </span>
              </div>
              <div *ngIf="loginPhoneForm.get('code')?.invalid && loginPhoneForm.get('code')?.touched" class="text-red-500">
                <small>⚠️ {{ 'LOGIN.REQUIRED_CODE' | translate }}</small>
              </div>
              <span *ngIf="loginPhoneForm.get('code')?.errors?.['pattern']"> ⚠️ {{ 'LOGIN.CODE_LENGHT' | translate }} </span>
            </div>
            <div *ngIf="showCodeInput" class="text-primary cursor-pointer" (click)="onSubmitPhone()">
              <p class="text-sm">Reenviar el c&oacute;digo</p>
            </div>

            <button *ngIf="showCodeInput" (click)="onVerifyCode()" class="btn btn-success w-full mt-2">Verificar código</button>
          </form>

          <form *ngIf="!isPhoneLogin" [formGroup]="loginForm" class="space-y-5 dark:text-white" (ngSubmit)="onSubmit()">
            <div>
              <label for="Email">{{ 'LOGIN.EMAIL' | translate }}</label>
              <div class="relative text-white-dark">
                <input
                  id="Email"
                  type="email"
                  formControlName="email"
                  placeholder="{{ 'LOGIN.ENTEREMAIL' | translate }}"
                  class="form-input ps-10 placeholder:text-white-dark animate__animated animate__fadeInTopRight animated__delay-1s"
                />
                <span class="absolute start-4 top-1/2 -translate-y-1/2">
                  <icon-mail class="text-primary animate__animated animated__delay-1s animate__fadeInTopLeft" [fill]="true"></icon-mail>
                </span>
              </div>
              <!-- Mensaje de error -->
              <div *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched" class="text-red-500">
                <small *ngIf="loginForm.get('email')?.errors?.['required']"> ⚠️{{ 'LOGIN.EMAILREQUIRED' | translate }} </small>
                <small *ngIf="loginForm.get('email')?.errors?.['email']"> ⚠️{{ 'LOGIN.INVALIDEMAIL' | translate }} </small>
              </div>
            </div>

            <div>
              <label for="Password">{{ 'REGISTER.PASSWORD' | translate }}</label>
              <div class="relative text-white-dark">
                <input
                  id="Password"
                  type="password"
                  formControlName="password"
                  placeholder="{{ 'REGISTER.ENTERPASSWORD' | translate }}"
                  class="form-input ps-10 placeholder:text-white-dark animate__animated animate__fadeInTopRight animated__delay-1s"
                />
                <span class="absolute start-4 top-1/2 -translate-y-1/2">
                  <icon-lock-dots class="text-primary animate__animated animated__delay-1s animate__fadeInTopLeft" [fill]="true"></icon-lock-dots>
                </span>
              </div>
              <!-- Mensaje de error -->
              <div *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched" class="text-red-500">
                <small *ngIf="loginForm.get('password')?.errors?.['required']"> ⚠️{{ 'LOGIN.PASSWORDREQUIRED' | translate }} </small>
                <small *ngIf="loginForm.get('password')?.errors?.['minlength']"> ⚠️{{ 'LOGIN.PASSWORDMINLENGTH' | translate }} </small>
              </div>
            </div>

            <!-- <div>
              <label class="flex cursor-pointer items-center">
                <input type="checkbox" formControlName="acceptTerms" class="form-checkbox bg-white dark:bg-black" />
                <span class="text-white-dark">{{ 'LOGIN.CONDITIONS' | translate }}</span>
              </label>
              <div *ngIf="loginForm.get('acceptTerms')?.invalid && loginForm.get('acceptTerms')?.touched" class="text-red-500">
                ⚠️<small>Debes aceptar los términos y condiciones.</small>
              </div>
            </div> -->

            <button
              type="submit"
              [disabled]="loginForm.invalid"
              class="btn btn-primary !mt-6 w-full border-0 uppercase text-black shadow-[0_10px_20px_-10px_rgba(67,97,238,0.44)] animate-pulse"
            >
              {{ 'LOGIN.BUTTON' | translate }}
            </button>
          </form>
          <!-- <a
            (click)="modal13.open()"
            class="cursor-pointer text-primary underline transition hover:text-black dark:hover:text-white animate__animated animate__delay-1s animate__flipInY"
          >
            <p class="text-white-dark animate__animated animate__delay-1s animate__flipInY text-center">{{ 'LOGIN.RECOVER_PASSWORD' | translate }}</p>
          </a> -->
          <div class="text-center mt-4">
            <a
              href="https://tuulapp.com/"
              target="_blank"
              class="inline-block py-1 px-1 text-sm font-semibold text-black bg-greenTuuLapp rounded-md hover:text-white hover:bg-primary focus:outline-none focus:ring-2 focus:ring-primary transition"
            >
              <img class="w-8 inline-block" src="../../../../assets/images/tuercas.png" alt="" />
              {{ 'LOGIN.Login_as_workshop' | translate }}
              <img class="w-8 inline-block" src="../../../../assets/images/tuercas.png" alt="" />
            </a>
          </div>
          <!-- MODAL RECUPERAR PASSWORD -->
          <div>
            <!-- Trigger -->
            <!-- <a type="button" class="btn btn-danger" (click)="modal13.open()">¿Olvidaste tu contraseña?</a> -->

            <!-- Modal Recuperar Password -->
            <!-- <ngx-custom-modal
              #modal13
              [customClass]="store.rtlClass === 'rtl' ? 'modal-top animate animate-fade-in-right' : 'modal-center animate animate-fade-in-left'"
            >
              <ng-template #modalHeader>
                <div><img class="h-16 w-40" src="../../../../assets/images/logo-24.png" alt="" /> Recupera tu cuenta</div>
              </ng-template>
              <ng-template #modalBody>
                <form [formGroup]="recoverPasswordForm" class="space-y-4">
                  <p>
                    Protege tu contraseña, no la compartas con nadie. Usa combinaciones seguras y cámbiala regularmente. Refuerza tu seguridad con autenticación
                    en dos pasos. 🔒
                  </p>
                  <ul>
                    <li class="my-2">1. Ingresa tu correo electr&oacute;nico o n&uacute;mero de m&oacute;vil.</li>
                    <li class="my-2">2. Recibir&aacute;s un c&oacute;digo de verificaci&oacute;n.</li>
                    <li class="my-2">3. Ingresa el c&oacute;digo de verificaci&oacute;n en el campo correspondiente.</li>
                    <li class="my-2" *ngIf="showVerificationInput">4. Ingresa tu nueva contraseña.</li>
                    <li class="my-2">5. Haz clic en "{{ showVerificationInput ? 'Cambiar Contraseña' : 'Enviar Código' }}".</li>
                  </ul>

                  <div class="mt-4">
                    <input
                      type="text"
                      formControlName="emailOrPhone"
                      placeholder="Correo electrónico o número de teléfono"
                      class="w-full border-2 border-gray-500 rounded-lg px-4 py-2"
                    />
                  </div>

                  <div *ngIf="showVerificationInput" class="mt-4">
                    <input
                      type="text"
                      formControlName="verificationCode"
                      placeholder="Código de verificación"
                      class="w-full border-2 border-gray-500 rounded-lg px-4 py-2"
                    />
                  </div>

                  <div *ngIf="showVerificationInput" class="mt-4">
                    <input
                      type="password"
                      formControlName="newPassword"
                      placeholder="Nueva contraseña"
                      class="w-full border-2 border-gray-500 rounded-lg px-4 py-2"
                    />
                  </div>
                </form>
              </ng-template>
              <ng-template #modalFooter>
                <button type="button" (click)="modal13.close()" class="btn btn-outline-danger">Cancelar</button>
                <button type="button" *ngIf="!showVerificationInput" (click)="requestPasswordRecovery(modal13)" class="btn btn-primary ltr:ml-4 rtl:mr-4">
                  Enviar Código
                </button>
                <button type="button" *ngIf="showVerificationInput" (click)="resetPassword(modal13)" class="btn btn-primary ltr:ml-4 rtl:mr-4">
                  Cambiar Contraseña
                </button>
              </ng-template>
            </ngx-custom-modal> -->
          </div>
          <app-networks></app-networks>
          <div class="text-center dark:text-white animate__animated animate__delay-1s animate__flipInY">
            {{ 'LOGIN.REGISTER' | translate }}
            <a
              (click)="GoToRegister()"
              class="uppercase cursor-pointer text-primary underline transition hover:text-black dark:hover:text-white animate__animated animate__delay-1s animate__flipInY"
            >
              {{ 'LOGIN.LINK' | translate }}
            </a>
          </div>
        </div>
        <div class="flex flex-col items-center">
          <p class="w-full text-center pb-5 text-black dark:text-white animate__animated animate__delay-1s animate__flipInY flex items-center justify-center">
            © {{ currYear }} PITZON. {{ 'HOME.FOOTER' | translate }} By&nbsp;
            <img class="w-16 inline-block absolute bottom-0" src="https://tuulapp.com/assets/images/logo/logo.svg" alt="Tuulapp Logo" />
          </p>
        </div>
      </div>
    </div>
    <div
      *ngIf="showAssistance"
      (click)="goToassistant()"
      class="group cursor-pointer animate-pulse border border-primary rounded-full absolute top-1/2 bottom-40 right-2 h-16 w-16 -translate-y-1/2"
    >
      <img src="../../../../assets/images/juan2.png" alt="juanca-face" class="w-16 absolute animate__animated animate__delay-1s animate__flipInY" />

      <!-- Tooltip -->
      <span
        class="opacity-0 group-hover:opacity-100 transition-opacity bg-gray-900 text-white text-xs rounded py-1 px-2 absolute bottom-full right-1/2 translate-x-1/2 mb-2"
      >
        Asistencia Virtual Gratuita
      </span>
    </div>
  </div>
</div>
